/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EuPagoInit
 */
export interface EuPagoInit {
    /**
     * Transaction ID. You require this ID to confirm the transaction
     * @type {number}
     * @memberof EuPagoInit
     */
    id?: number;
    /**
     * References in Format: <b>entitades.referencias</b>
     * @type {string}
     * @memberof EuPagoInit
     */
    reference?: string;
}

/**
 * Check if a given object implements the EuPagoInit interface.
 */
export function instanceOfEuPagoInit(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EuPagoInitFromJSON(json: any): EuPagoInit {
    return EuPagoInitFromJSONTyped(json, false);
}

export function EuPagoInitFromJSONTyped(json: any, ignoreDiscriminator: boolean): EuPagoInit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'reference': !exists(json, 'reference') ? undefined : json['reference'],
    };
}

export function EuPagoInitToJSON(value?: EuPagoInit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'reference': value.reference,
    };
}

